import {
  FETCH_EASY_JOIN_CODES_FULFILLED,
  CREATE_EASY_JOIN_CODE_FULFILLED,
  UPDATE_EASY_JOIN_CODE_FULFILLED,
  DELETE_EASY_JOIN_CODES_FULFILLED,
  EASY_JOIN_CLEAR_LAST_CREATED,
  EASY_JOIN_CLEAR_LAST_UPDATED,
} from './actionTypes';

const initialState = {
  codes: [],
  lastCreated: null,
  lastUpdated: null,
};

export default function easyJoinDataReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_EASY_JOIN_CODES_FULFILLED:
      return { ...state, codes: action.payload, lastCreated: null };
    case CREATE_EASY_JOIN_CODE_FULFILLED:
      return {
        ...state,
        codes: [action.payload, ...state.codes],
        lastCreated: action.payload,
      };
    case UPDATE_EASY_JOIN_CODE_FULFILLED:
      return {
        ...state,
        codes: state.codes.map((code) => (code.id === action.payload.id ? action.payload : code)),
        lastUpdated: action.payload,
      };
    case DELETE_EASY_JOIN_CODES_FULFILLED:
      return {
        ...state,
        codes: state.codes.filter((code) => !action.payload.includes(code.id)),
      };
    case EASY_JOIN_CLEAR_LAST_CREATED:
      return { ...state, lastCreated: null };
    case EASY_JOIN_CLEAR_LAST_UPDATED:
      return { ...state, lastUpdated: null };
    default:
      return state;
  }
}
